import React,{ useEffect, useRef, useCallback, useMemo} from 'react'
//import { useSelector } from 'react-redux'
import { doc, updateDoc } from "firebase/firestore";
import {db} from '../../config/firebaseConfig'
import NotificationBar from './NotificationBar';
const NotificationPanel = ({notifications, fetchmoreNotification, load, setLoad, isEmpty, EndData, setShowNotification}) => {
  
  function subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = (intHours * 60) * 60 * 1000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }

  const observer=useRef();

  const lastNotification=useCallback(node=>{
    if(load) return

    if(observer.current){
      observer.current.disconnect()
    }
      observer.current=new IntersectionObserver(entries=>{
        if(entries[0].isIntersecting){
          if(!isEmpty && !EndData){
            setLoad(true)
            fetchmoreNotification() 
          }
        }
      })
    if(node){
      observer.current.observe(node)
    }


  },[load]);

  
  useEffect(() => {
    let data=notifications.filter(d=>d.read==false);
    if(data.length>0){
      data.map((n,i)=>{
        const timer= setTimeout(() => {
          readNotification(n.id)
        }, 2000);
        return () => clearTimeout(timer);
        
      })
      data=[];
    }
    
  }, [notifications]);

  const readNotification=async(id)=>{
    const notifyDoc = doc(db, "Notifications", id);
    await updateDoc(notifyDoc, {
      read: true
    });
  }

  const recentNotifications=useMemo(()=>notifications.filter((n)=>n.createdAt.toDate()>=subtractTimeFromDate(new Date(), 4)), [notifications]);
  const earlierNotifications=useMemo(()=>notifications.filter((n)=>n.createdAt.toDate()<subtractTimeFromDate(new Date(), 4)), [notifications]);
  const unreadCount=useMemo(()=>notifications.filter((n)=>n.read===false).length, [notifications]);

  return (
    <div className='notification-panel'>
       <div className='notification-panel-head'>
        <div>
          <p className='notification-panel-eyebrow'>Updates</p>
          <h4 className='notification-panel-title'>Notifications</h4>
        </div>
        <div className='notification-panel-count'>
          <span>{unreadCount}</span>
          unread
        </div>
       </div>
       
       {notifications.length>0 &&
       <div className='notification-panel-scroll'>
         {recentNotifications.length>0 &&
         <h4 className='notification-panel-section'>Recent</h4>
         }
        {recentNotifications.map((n,i)=>(
          <div key={n.id || `${n.title}-${i}`}>
          <div>
            <NotificationBar notification={n} setShowNotification={setShowNotification}/>
           </div>
          </div>
          ))
        }

        {earlierNotifications.length>0 &&
        <h4 className='notification-panel-section'>Earlier</h4>
        }
            {earlierNotifications.map((n,i)=>(
              <div key={n.id || `${n.title}-${i}`}>
                <div>
                <NotificationBar  notification={n} setShowNotification={setShowNotification}/>
                </div>
              </div>

              ))
            }
        {!EndData && <div ref={lastNotification} className='notification-panel-sentinel'/>}
        {load &&
       <div className='notification-panel-loader'/>
        }
       
        </div>
        }
    
        {isEmpty &&
        <div className='notification-empty'>
          <span/>
          <h4>No notifications</h4>
          <p>New task updates will appear here.</p>
        </div>
        }
    </div>
  )
}

export default NotificationPanel
